module.exports = __webpack_public_path__ + "static/img/adminImg3.02bfd59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adminImg3.png
// module id = UuVb
// module chunks = 2